export default "__VITE_ASSET__BTUivzDJ__"